/**
 * @generated SignedSource<<2ad5113245d6bef656fbe27839cd6a2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type diligenceCellPanel_Query$variables = Record<PropertyKey, never>;
export type diligenceCellPanel_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
  }>;
};
export type diligenceCellPanel_Query = {
  response: diligenceCellPanel_Query$data;
  variables: diligenceCellPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "bankAccounts",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "last4",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Stakeholder",
    "kind": "LinkedField",
    "name": "allStakeholders",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "diligenceCellPanel_Query",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "diligenceCellPanel_Query",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2c1bab690039a3c2ba6d2bf107eeae55",
    "id": null,
    "metadata": {},
    "name": "diligenceCellPanel_Query",
    "operationKind": "query",
    "text": "query diligenceCellPanel_Query {\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n  }\n  allStakeholders {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc908f16fa3ff38dd721ff5887965c32";

export default node;
